import { OrderCustomerActionDTOTypeIdEnum } from '@reposit/api-client';
import { find } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import CardIconActive from '../../assets/svg/progress/card-active.svg';
import CardIcon from '../../assets/svg/progress/card.svg';
import FinishIconActive from '../../assets/svg/progress/flag-active.svg';
import FinishIcon from '../../assets/svg/progress/flag.svg';
import PencilIconActive from '../../assets/svg/progress/pencil-active.svg';
import PencilIcon from '../../assets/svg/progress/pencil.svg';
import PersonActiveIcon from '../../assets/svg/progress/person-active.svg';
import PersonIcon from '../../assets/svg/progress/person.svg';
import ThumbIconActive from '../../assets/svg/progress/thumbs-up-active.svg';
import ThumbIcon from '../../assets/svg/progress/thumbs-up.svg';
import TickIconActive from '../../assets/svg/progress/tick-active.svg';
import TickIcon from '../../assets/svg/progress/tick.svg';
import Stage, { StageProps } from './Stage';

interface ProgressProps {
  currentUrl: string;
  orderActions: any[];
}

const Stages: StageProps[] = [
  {
    label: 'About You',
    icon: PersonIcon,
    iconActive: PersonActiveIcon,
    urls: ['/about-you', '/address-history'],
    actions: [OrderCustomerActionDTOTypeIdEnum.REPOSITADDRESSHISTORY, OrderCustomerActionDTOTypeIdEnum.REPOSITABOUTYOU],
  },
  {
    label: 'Eligibility',
    icon: ThumbIcon,
    iconActive: ThumbIconActive,
    urls: ['/referencing'],
    actions: [OrderCustomerActionDTOTypeIdEnum.REPOSITREFERENCING],
  },
  {
    label: 'Confirm',
    icon: TickIcon,
    iconActive: TickIconActive,
    urls: ['/confirm'],
    actions: [OrderCustomerActionDTOTypeIdEnum.REPOSITCONFIRM],
  },
  {
    label: 'Terms',
    icon: PencilIcon,
    iconActive: PencilIconActive,
    urls: ['/sign'],
    actions: [OrderCustomerActionDTOTypeIdEnum.REPOSITSIGN],
  },
  {
    label: 'Addendum',
    icon: PencilIcon,
    iconActive: PencilIconActive,
    urls: ['/addendum'],
    actions: [OrderCustomerActionDTOTypeIdEnum.REPOSITSIGNADDENDUM],
  },
  {
    label: 'Pay',
    icon: CardIcon,
    iconActive: CardIconActive,
    urls: ['/pay'],
    actions: [OrderCustomerActionDTOTypeIdEnum.REPOSITPAY],
  },
  {
    label: 'Finish',
    icon: FinishIcon,
    iconActive: FinishIconActive,
    urls: ['/finish'],
  },
];

const Wrapper = styled.div`
  overflow-y: auto;
  margin: 0;
  padding: 0 0 6px;
`;

const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 930px;

  &:after {
    content: '';
    display: block;
    background: ${(props) => props.theme.colors.dividerDark};
    height: 1px;
    position: absolute;
    top: 50%;
    width: 100%;
  }
`;

const isActive = (currentUrl: string, urls?: string[]): boolean => {
  if (!urls) return false;
  return !!urls.find((url) => currentUrl.includes(`${url}`));
};

const getStages = (orderActions: any[]) => {
  let stages;

  stages = Stages.map((stage) => {
    const foundActions = orderActions.filter((orderAction) => stage.actions && stage.actions.includes(orderAction.typeId));
    stage.isComplete = foundActions.every((a) => a.completedAt);
    return stage;
  });

  // remove referencing stage if no actions
  stages = stages.filter((stage) =>
    find(orderActions, (orderAction) => stage.actions && stage.actions.includes(orderAction.typeId))
  );

  return stages;
};

const finishStage = Stages.pop();

const RepositProgress: React.FC<ProgressProps> = ({ currentUrl, orderActions }) => {
  const stages = getStages(orderActions);

  return (
    <Wrapper>
      <Inner>
        {stages.map((stage) => (
          <Stage
            key={stage.label}
            label={stage.label}
            isComplete={stage.isComplete}
            isActive={isActive(currentUrl, stage.urls)}
            icon={stage.icon}
            iconActive={stage.iconActive}
          />
        ))}
        {finishStage && (
          <Stage
            key={finishStage.label}
            label={finishStage.label}
            isComplete={finishStage.isComplete}
            isActive={isActive(currentUrl, finishStage.urls)}
            icon={finishStage.icon}
            iconActive={finishStage.iconActive}
          />
        )}
      </Inner>
    </Wrapper>
  );
};

export default RepositProgress;
